import { useTranslator } from '@Localization';
import { AutocompleteValue } from '@mui/base';
import { Autocomplete, AutocompleteProps } from '@mui/joy';
import classNames from 'classnames';
import { ReactElement } from 'react';

export const Select = <
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = true,
  FreeSolo extends boolean | undefined = false,
>({
  className,
  disableClearable,
  blurOnSelect,
  openOnFocus,
  selectOnFocus,
  autoHighlight,
  placeholder,
  value,
  ...rest
}: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>): ReactElement => {
  const { t } = useTranslator();

  const hidePlaceholder = (Array.isArray(value) && value.length) || (!Array.isArray(value) && value);

  return (
    <Autocomplete
      {...rest}
      value={(value === undefined ? null : value) as AutocompleteValue<T, Multiple, DisableClearable, FreeSolo> | undefined}
      disableClearable={(disableClearable ?? true) as DisableClearable}
      className={classNames('s-select', className)}
      placeholder={hidePlaceholder ? undefined : (placeholder ?? t('select_dots'))}
      blurOnSelect={blurOnSelect ?? false}
      openOnFocus={openOnFocus ?? true}
      selectOnFocus={selectOnFocus ?? false}
      autoHighlight={autoHighlight ?? true}
    />
  );
};
